"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconArrowLeftCircleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM3.29289 8.70717C2.90237 8.31664 2.90237 7.68348 3.29289 7.29295L6.29289 4.29295C6.68342 3.90243 7.31658 3.90243 7.70711 4.29295C8.09763 4.68348 8.09763 5.31664 7.70711 5.70717L6.41435 6.99992L11.9999 6.9996C12.5522 6.99957 13 7.44726 13 7.99955C13 8.55183 12.5523 8.99957 12.0001 8.9996L6.41407 8.99992L7.70711 10.293C8.09763 10.6835 8.09763 11.3166 7.70711 11.7072C7.31658 12.0977 6.68342 12.0977 6.29289 11.7072L3.29289 8.70717Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M9.99988 1C14.9704 1 18.9999 5.02944 18.9999 10C18.9999 14.9706 14.9704 19 9.99988 19C5.02931 19 0.999878 14.9706 0.999878 10C0.999878 5.02944 5.02931 1 9.99988 1ZM3.99988 9.99985C3.99988 9.73463 4.10523 9.48028 4.29277 9.29274L8.29277 5.29269C8.68329 4.90216 9.31645 4.90216 9.70698 5.29268C10.0975 5.6832 10.0975 6.31637 9.70699 6.7069L7.41391 9H14.9999C15.5522 9 15.9999 9.44772 15.9999 10C15.9999 10.5523 15.5522 11 14.9999 11H7.41427L9.70698 13.2927C10.0975 13.6832 10.0975 14.3164 9.70699 14.7069C9.31647 15.0974 8.6833 15.0974 8.29278 14.7069L4.29278 10.707C4.10524 10.5194 3.99988 10.2651 3.99988 9.99985Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM9.29289 16.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289C11.0976 7.68342 11.0976 8.31658 10.7071 8.70711L8.41421 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H8.41421L10.7071 15.2929C11.0976 15.6834 11.0976 16.3166 10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 1.00001C24.2843 1.00001 31 7.71573 31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1.00001 16 1.00001ZM6 16.0002C5.99999 15.5797 6.17645 15.1785 6.48639 14.8944L12.4864 9.39421C13.0971 8.83441 14.0459 8.87565 14.6057 9.48632C15.1655 10.097 15.1243 11.0458 14.5136 11.6056L11.3562 14.5H24.5C25.3284 14.5 26 15.1716 26 16C26 16.8284 25.3284 17.5 24.5 17.5H11.3562L14.5136 20.3942C15.1243 20.954 15.1655 21.9028 14.6058 22.5135C14.046 23.1242 13.0971 23.1655 12.4864 22.6057L6.48643 17.1059C6.17648 16.8218 6.00001 16.4206 6 16.0002Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;